// let jwt = require('jsonwebtoken');
import { jwtDecode } from 'jwt-decode';
const verifyToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch (error) {
    return false;
  }
};

export { verifyToken };
